import React, { useState } from "react";
import {Button, Typography} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import colorBar from '../../assets/img/color_bar.png';
import {AcnColorTheme} from "../../assets/css/AcnColorTheme";
import {fontUnit, heightUnit, padGinUnit, widthUnit} from "../../utils/DeviceManager";
const iOS = require('is-ios');

interface TemplateComponentProps {
    content: JSX.Element;
    onNext?: () => void;
    isCanNext?: boolean;
    nextText?: string;
    optionNext?: () => void;
    optionText?: string;
    background?: string;
    btnBackground?: string;
    noPadding?: boolean;
    showHeadBar?: boolean;
    footerText?: string;

}
function TemplateComponent(props: TemplateComponentProps) {
    const { content, onNext, isCanNext, nextText, optionNext, optionText, background, btnBackground, noPadding, showHeadBar = true, footerText} = props;
    const classes = useStyles();
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    const setHeightHaveButton = () => {
        if(isCanNext) {
            return screenHeight-(padGinUnit(48)+heightUnit(56))}
        return screenHeight;
    }
    const doOnClick = () => {
        if (onNext && isCanNext) {
            onNext()
        }
    }

    return (
        <div style={{background: background ? background : AcnColorTheme.ghostWhite}} className={classes.centerScreen}>
            <div style={{
                alignContent: "center",
                width: "100%",
                overflow: "none",
            }}>
                {showHeadBar && <img src={colorBar} alt="head bar" className={classes.headBar} />}
                <div className={classes.content}
                    style={{
                        paddingLeft: noPadding ? padGinUnit(0): padGinUnit(24),
                        paddingRight: noPadding ? padGinUnit(0): padGinUnit(24),
                        paddingTop: noPadding ? padGinUnit(0): padGinUnit(24),
                        paddingBottom: padGinUnit(32),
                        // height: screenHeight-(padGinUnit(48)+heightUnit(56)), // viewport height - next button height
                        height: setHeightHaveButton(),
                        overflow: 'auto'
                }}>
                    {
                        content
                    }
                </div>
            </div>
            {footerText && <Typography className={classes.footerText}>{footerText}</Typography>}
            {
                onNext && (
                    <div style={{
                        position: "fixed",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        // paddingBottom: padGinUnit(32),
                        paddingBottom: !iOS? padGinUnit(20) : padGinUnit(32),
                        paddingTop: btnBackground? padGinUnit(14): 0,
                        background: btnBackground? btnBackground : background ? background : AcnColorTheme.ghostWhite
                    }}>
                        <div
                            style={{
                                // marginTop: padGinUnit(8),
                                marginTop: padGinUnit(16),
                                paddingLeft: padGinUnit(24),
                                paddingRight: padGinUnit(24)
                            }}>
                            <Button
                                onClick={doOnClick}
                                style={{
                                    width: widthUnit(327),
                                    height: heightUnit(56),
                                    minHeight: 42,
                                    backgroundColor: isCanNext? AcnColorTheme.darkBlue: AcnColorTheme.grey50,
                                    color: isCanNext? "white":"#BCC1C7",
                                    opacity: 1,
                                    borderRadius: 8,
                                    fontSize: fontUnit(18),
                                    fontWeight: "bold",
                                    textTransform: "none"
                                }}>
                                {nextText ? nextText : "ถัดไป"}
                            </Button>
                            {
                                optionNext ?
                                    (
                                        <Button
                                            onClick={optionNext}
                                            style={{
                                                width: window.innerWidth * 0.85,
                                                height: heightUnit(56),
                                                minHeight: 42,
                                                background: "white",
                                                marginTop: padGinUnit(8),
                                                color: AcnColorTheme.secondaryRed,
                                                borderRadius: 8,
                                                fontSize: fontUnit(18),
                                                fontWeight: "bold",
                                                textTransform: "none",
                                                border: "1px solid #F5333F",
                                            }}>
                                            {optionText ? optionText : "ปิด"}
                                        </Button>
                                    ) : <div/>
                            }
                        </div>
                    </div>
                )
            }
        </div>
    );
}

const useStyles = makeStyles(() => ({
    headBar: {
        width: '100vw'
    },
    footerText: {
        margin: padGinUnit(24),
        position: 'absolute',
        bottom: 0,
        fontFamily: 'Prompt-Regular',
        fontWeight: 400
    },
    centerScreen: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'center',
    },
    content: {
        '&::-webkit-scrollbar': {
            display: 'none'
        },
    }
}))

export default TemplateComponent;
